import { Box } from "@mui/material";
import Lottie from "lottie-react";
import { useLotties } from "../../assets/Lotties/animations/lotties";
import { colorizeLottieDynamic } from "../../assets/Lotties/animations/colorizeLottieDynamic";
import { useMemo } from "react";

interface LoaderScreenProps {
  size?: number | string;
  color?: string;
  variant?: "orange" | "green";
}

const LoaderScreen: React.FC<LoaderScreenProps> = ({ size = 280, color, variant = "orange" }) => {
  const { LottieCarga, LottieCargaVerde } = useLotties();

  const animationData = useMemo(() => {
    const baseLottie = variant === "green" ? LottieCargaVerde : LottieCarga;
    if (color && baseLottie) {
      return colorizeLottieDynamic(baseLottie, color);
    }
    return baseLottie;
  }, [LottieCarga, LottieCargaVerde, color, variant]);

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        transform: "translate(0%, 0%)",
        backgroundColor: "rgba(30, 41, 71, 0.45)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={{
          width: size,
          height: size,
        }}
      />
    </Box>
  );
};

export default LoaderScreen;
